<template>
  <div class="Results" @click="broadcast('close-menus')">
    <ResultsGrid v-if="display === 'grid'"></ResultsGrid>
    <ResultsList v-else></ResultsList>

    <nav class="pagination" role="navigation" aria-labelledby="pagination-heading">
      <h4 id="pagination-heading" class="visually-hidden">Pagination</h4>
      <ul class="pager__items js-pager__items">

        <li class="pager__item pager__item--first pagination__first" v-if="currentPage > 1" @click="broadcast('show-first')">
          <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><g fill="#D21B7D" fill-rule="nonzero"><path d="M0 1.529L1.65 0 10 8l-8.35 8L0 14.471 6.723 8z"/><path d="M6 1.529L7.65 0 16 8l-8.35 8L6 14.471 12.723 8z"/></g></svg>
          <span>First</span>
        </li>

        <li class="pager__item pager__item--previous pagination__prev" v-if="currentPage > 1" @click="broadcast('show-less')">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16"><path d="M0 1.529L1.65 0 10 8l-8.35 8L0 14.471 6.723 8z" fill="#D21B7D"/></svg>
            <span>Previous</span>
        </li>

        <li class="pager__item pager__item--ellipsis" v-if="currentPage - 4 > 0" role="presentation">&hellip;</li>

        <li class="pager__item page_number" v-if="currentPage - 3 > 0" @click="broadcast('show-less3')">{{ currentPage - 3 }}</li>

        <li class="pager__item page_number" v-if="currentPage - 2 > 0" @click="broadcast('show-less2')">{{ currentPage - 2 }}</li>

        <li class="pager__item page_number" v-if="currentPage - 1 > 0" @click="broadcast('show-less')">{{ currentPage - 1 }}</li>

        <li class="pager__item page_number is-active">{{ currentPage }}</li>

        <li class="pager__item page_number" v-if="currentPage + 1 < resultsData.totalPages" @click="broadcast('show-more')">{{ currentPage + 1 }}</li>

        <li class="pager__item page_number" v-if="currentPage + 2 < resultsData.totalPages" @click="broadcast('show-more2')">{{ currentPage + 2 }}</li>

        <li class="pager__item page_number" v-if="currentPage + 3 < resultsData.totalPages" @click="broadcast('show-more3')">{{ currentPage + 3 }}</li>

        <li class="pager__item pager__item--ellipsis" v-if="currentPage + 4 < resultsData.totalPages" role="presentation">&hellip;</li>

        <li class="pager__item pager__item--next pagination__next" v-if="resultsData.totalPages > 1 && this.currentPage < resultsData.totalPages" @click="broadcast('show-more')">
          <span>Next</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16"><path d="M0 1.529L1.65 0 10 8l-8.35 8L0 14.471 6.723 8z" fill="#D21B7D"/></svg>
        </li>

        <li class="pager__item pager__item--last pagination__last" v-if="resultsData.totalPages > 1 && this.currentPage < resultsData.totalPages" @click="broadcast('show-last')" title="Go to last page">
            <span>Last</span>
            <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><g fill="#D21B7D" fill-rule="nonzero"><path d="M0 1.529L1.65 0 10 8l-8.35 8L0 14.471 6.723 8z"/><path d="M6 1.529L7.65 0 16 8l-8.35 8L6 14.471 12.723 8z"/></g></svg>
        </li>
      </ul>
    </nav>

    <!--<div class="more" v-if="currentPage > 1" @click="broadcast('show-less')" >-->
      <!--<svg width="16px" height="10px" viewBox="0 0 16 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">-->
          <!--<defs></defs>-->
          <!--<g id="home-and-interior" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">-->
              <!--<g id="search-&#45;&#45;results-&#45;&#45;grid" transform="translate(-796.000000, -1569.000000)" fill="#D21B7D" fill-rule="nonzero">-->
                  <!--<g id="Group-29" transform="translate(485.000000, 1543.000000)">-->
                      <!--<polygon id="Page-1" transform="translate(319.000000, 31.000000) rotate(0.000000) translate(-319.000000, -31.000000) " points="324 37.4712613 322.349888 39 314 31 322.349888 23 324 24.5287387 317.276807 31"></polygon>-->
                  <!--</g>-->
              <!--</g>-->
          <!--</g>-->
      <!--</svg>-->
      <!--&nbsp; <strong>Back to Page {{ currentPage - 1 }} </strong>-->
    <!--</div>-->
    <!--<div class="spacer more" v-else></div>-->

    <!--<div v-if="resultsData.totalPages > this.currentPage" class="more current"><strong> Page {{ currentPage }} </strong> &nbsp;</div>-->
    <!--<p>Total pages: {{ resultsData.totalPages }}</p>-->

    <!--<div v-if="resultsData.totalPages > this.currentPage" @click="broadcast('show-more')" class="more"><strong>See more on Page {{ currentPage + 1 }} </strong> &nbsp;-->
      <!--<svg width="16px" height="10px" viewBox="0 0 16 10" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">-->
          <!--<defs></defs>-->
          <!--<g id="home-and-interior" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">-->
              <!--<g id="search-&#45;&#45;results-&#45;&#45;grid" transform="translate(-796.000000, -1569.000000)" fill="#D21B7D" fill-rule="nonzero">-->
                  <!--<g id="Group-29" transform="translate(485.000000, 1543.000000)">-->
                      <!--<polygon id="Page-1" transform="translate(319.000000, 31.000000) rotate(-180.000000) translate(-319.000000, -31.000000) " points="324 37.4712613 322.349888 39 314 31 322.349888 23 324 24.5287387 317.276807 31"></polygon>-->
                  <!--</g>-->
              <!--</g>-->
          <!--</g>-->
      <!--</svg>-->
    <!--</div>-->
    <!--<div class="spacer more" v-else></div>-->


    <div id="vsmodalbg" v-if="showPreviewModal || showShareModal || (locked && showSpinner)">

      <div v-if="locked">
        <img class="Spinner" src="/themes/custom/microfiche/search/src/assets/spinner.svg"/>
      </div>

      <button v-if="showPreviewModal" @click="showPreviewModal = false" class="vsmodalclose dialogue-quickview__close" aria-label="close">
        <svg width="22" height="22" xmlns="http://www.w3.org/2000/svg">
          <g stroke="#06379D" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="square">
            <path d="M20.037 1.882L1.652 20.267M20.037 20.267L1.652 1.882"></path>
          </g>
        </svg> <span class="visually-hidden">Close</span>
      </button>

      <button v-if="showShareModal" @click="showShareModal = false" class="vsmodalclose dialogue-share__close" aria-label="close">
        <svg width="22" height="22" xmlns="http://www.w3.org/2000/svg"><g stroke="#06379D" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="square"><path d="M20.037 1.882L1.652 20.267M20.037 20.267L1.652 1.882"></path></g></svg>    <span class="visually-hidden">Close</span>
      </button>

      <div v-if="showPreviewModal" v-html="previewHTML" id="vsmodalpreview" class="filmstrip-tile__dialogue-quickview js-show" hidden="" style="top: 215px;"></div>

      <div v-if="showShareModal" id="vsmodalshare" class="filmstrip-tile__dialogue-share-inside">
        <section class="dialogue-share">
          <div class="ShareHTML" v-html="shareHTML"></div>
        </section>
      </div>

    </div>
  </div>
</template>

<script>
import ResultsGrid from '@/components/ResultsGrid'
import ResultsList from '@/components/ResultsList'
import { mapGetters } from 'vuex'

export default {
  name: 'Results',
  components: {
    ResultsGrid,
    ResultsList
  },
  props: {
    display: {
      type: String,
      default: 'grid'
    },
  },
  mounted: function () {
    var $window = window

    // Here arg is the entire item.
    this.listenFor('show-share-modal', arg => {
      var $this = this
      var endpoint = '/node/' + arg.nid + '/share'
      var headers = {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*',
          'Accept': 'application/json'
        }
      }

      this.axios.get(endpoint, headers)
      .then(function (response) {
        $this.shareHTML = response.data
        $this.showShareModal = true

        // @TODO: This definitely seems like overkill, but addthis.toolbox() and addthis.layers.refresh() didn't work.
        delete window.addthis

        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5b5f30b9bbcae040')
        document.body.appendChild(addthisScript)

        window.addthis_share = {
          url: arg.url,
          title: arg.title,
        }
      })
    })

    this.listenFor('show-preview-modal', arg => {
      var $this = this
      var endpoint = '/node/' + arg + '/quickview'
      var headers = {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*',
          'Accept': 'application/json'
        }
      }

      this.axios.get(endpoint, headers)
      .then(function (response) {
        // console.log(response)
        $this.previewHTML = response.data
        $this.showPreviewModal = true
      })
    })
  },
  computed: {
    ...mapGetters({
      // searchTerm: 'getSearchTerm',
      // resultsItems: 'getResultsItems',
      currentPage: 'getCurrentPage',
      resultsData: 'getResultsData',
      locked: 'getLocked',
      showSpinner: 'getShowSpinner',
      // fullResponse: 'getFullResponse',
      // activeFilters: 'getActiveFilters',
    })
  },
  data () {
    return {
      showShareModal: false,
      showPreviewModal: false,
      shareHTML: null,
      previewHTML: null
    }
  },
  methods: {
    //
  }
};
</script>

<style scoped lang="scss">
.Results {

  .pagination {
    margin-bottom: 46px;
  }

  .more {
      padding:60px 0 60px;
      text-align: center;
      display: inline-block;
      width: 33.33%;
      cursor: pointer;

      &.current, &.spacer {
        color: #444;
        cursor: inherit;
      }
    }

  .pager__items {
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  li.pager__item {
    display: inline-block;
    margin-left: 10px;
    margin-right: 10px;
    cursor: pointer;
    font-weight: 800;

    &.page_number {
      color: #d40f7d;

      &:hover {
        text-decoration: underline;
      }
    }

    &.pager__item--next,
    &.pager__item--last {
      svg {
        margin: 0 0 0 8px;
      }
    }

    &.pager__item--first,
    &.pager__item--previous {
      svg {
        margin: 0 8px 0 0;
        transform: rotate(180deg);
      }
    }

    &.pager__item--next,
    &.pager__item--last,
    &.pager__item--first,
    &.pager__item--previous {
      &:hover {
        text-decoration: underline;
      }
    }

    &.is-active, &.pager__item--ellipsis {
      cursor: default;
      color: #333;

      &:hover {
        text-decoration: none;
      }
    }
  }
}

#vsmodalbg {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(4,27,53,.8);
  z-index: 99999;

  .Spinner {
    max-width: 200px;
    margin: 0 auto;
    display: block;
    position: fixed;
    left: calc(50% - 100px);
    top: 28vh;
  }

  /* Bug with v-html, ugh. https://github.com/vuejs/vue-loader/issues/749 */
  /deep/ .dialogue-quickview {
    width: 80%;
    left: 10%;
    top: 25vh;
    background: white;
    position: fixed;

    a{
      color: $pink !important;
    }

    .dialogue-quickview__copyright {
      padding: 16px 10px 17px;
    }

    .dialogue-quickview__teaser {
      padding: 58px !important;
    }

    .short-stack-teaser__metadata {
      margin: auto 0 auto 32px;
      -webkit-flex-basis: 250px;
      -ms-flex-preferred-size: 250px;
      flex-basis: 250px;
      -webkit-flex-shrink: 0;
      -ms-flex-negative: 0;
      flex-shrink: 0;
    }

    .short-stack-teaser__metadata-group {
      margin-bottom: 20px;
      padding-left: 32px;
    }
  }

  /deep/ .dialogue-share {
    width: 80%;
    left: 10%;
    top: 25vh;
    padding: 40px 52px 46px !important;
    background: white;
    position: fixed;
  }

  /deep/ .dialogue-share__close:not(.vsmodalclose) {
    display: none;
  }

  /deep/ .dialogue-share__close {
    position: absolute;
    top: 17vh;
    right: 10vw;
  }

  /deep/ .dialogue-quickview__close {
    position: absolute;
    top: 17vh;
    right: 10vw;
  }

  /deep/ .addthis_toolbox_sharing a {
    cursor: pointer;
  }
}
</style>
